// export const apiEndPoint = "http://localhost:8000/api/"
export const apiEndPoint = "https://webpsuher.onrender.com/api/"
